import { render, staticRenderFns } from "./legislationTable.vue?vue&type=template&id=17780774&"
import script from "./legislationTable.vue?vue&type=script&lang=js&"
export * from "./legislationTable.vue?vue&type=script&lang=js&"
import style0 from "./legislationTable.vue?vue&type=style&index=0&id=17780774&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports